<script setup lang="ts">
  import { HLToggle } from '@platform-ui/highrise'
  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
  })
  defineOptions({ inheritAttrs: false, name: 'CPToggle' })
</script>

<template>
  <HLToggle
    v-bind="$attrs"
    :id="props.id"
    class="ring-primary ring-offset-surface ring-offset-2 focus-visible:ring-2"
  />
</template>
